import {register} from '../modules/eventMap';

let isDirty = false;

export const hasUnsavedChanges = () => isDirty;

const handleUnload = (e) => {
    e.preventDefault();
    return (e.returnValue = '');
};

export const resetUnsavedChanges = () => {
    isDirty = false;
    window.removeEventListener('beforeunload', handleUnload);
};

function handleChange() {
    isDirty = true;
    window.addEventListener('beforeunload', handleUnload);
}

const setFormListeners = (form) => {
    const fields = form.querySelectorAll(
        'input:not([type="search"]), select, textarea'
    );
    [...fields].forEach((field) => {
        // eslint-disable-next-line no-constant-condition
        const eventType = (field.nodeName = 'SELECT' ? 'change' : 'input');
        field.addEventListener(eventType, handleChange);
    });
};

const init = (form) => {
    setFormListeners(form);
};

const unsavedChanges = () => {
    register('unsavedChanges', {
        init
    });
};

export {unsavedChanges};
